import type { ReactNode } from 'react';
import { Box } from '@simplywallst/ui-core';
import { useTileSideToggle } from '../../TileSideToggleContext';

type Props = {
  children: ReactNode;
};

export const Front = ({ children }: Props) => {
  const { tileSide, toggleTileSide } = useTileSideToggle();

  if (tileSide === 'back') return null;

  return (
    <Box
      position="relative"
      height="100%"
      onMouseOver={() => {
        toggleTileSide('back');
      }}
    >
      {children}
    </Box>
  );
};
